import {createSelector} from 'reselect';
import getAlipayPlusWalletDetails from './getAlipayPlusWalletDetails';

export default createSelector(
  [getAlipayPlusWalletDetails],
  details => details?.icon || {},
);
